var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"color":"#b300b3","indeterminate":""}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }